module.exports = __webpack_public_path__ + "static/holguin-2020-404d394ca32368d77ea75282bea82979.jpg";